document.addEventListener('click', function (e) {
  var tab = e.target.closest('[data-fam-cat-tab]');
  if (!tab) return;
  var tabs = tab.closest('[data-fam-cat-tabs]');
  if (!tabs) return;
  var id = tab.getAttribute('data-fam-cat-tab');

  tabs.querySelectorAll('[data-fam-cat-tab]').forEach(function (t) {
    t.classList.toggle('active', t === tab);
  });

  document.querySelectorAll('[data-fam-cat-panel]').forEach(function (panel) {
    panel.style.display = panel.getAttribute('data-fam-cat-panel') === id ? '' : 'none';
  });
});
